/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_EvaluatingInputs */

const en_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluating...`)
};

const de_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird ausgewertet...`)
};

const fr_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évaluation en cours...`)
};

const es_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluando...`)
};

const it_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valutazione...`)
};

const nl_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evalueren...`)
};

const pl_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocenianie...`)
};

const fi_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvioidaan...`)
};

const da_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluerer...`)
};

const sv_interview_practice_evaluating = /** @type {(inputs: Interview_Practice_EvaluatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvärderar...`)
};

/**
* | output |
* | --- |
* | "Evaluating..." |
*
* @param {Interview_Practice_EvaluatingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_evaluating = /** @type {((inputs?: Interview_Practice_EvaluatingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_EvaluatingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_evaluating(inputs)
	if (locale === "fr") return fr_interview_practice_evaluating(inputs)
	if (locale === "es") return es_interview_practice_evaluating(inputs)
	if (locale === "it") return it_interview_practice_evaluating(inputs)
	if (locale === "nl") return nl_interview_practice_evaluating(inputs)
	if (locale === "pl") return pl_interview_practice_evaluating(inputs)
	if (locale === "fi") return fi_interview_practice_evaluating(inputs)
	if (locale === "da") return da_interview_practice_evaluating(inputs)
	if (locale === "sv") return sv_interview_practice_evaluating(inputs)
	return en_interview_practice_evaluating(inputs)
});